import type { QueryKey } from '@tanstack/react-query';

import useQuery from '../../../ReactQuery/useQuery';
import { get } from '../../../redux/api';
import type { TeamWithAssociations } from '../../../../shared/types/routes/teams';

//  Actual function to fetch teams
function fetchTeams() {
  return get<TeamWithAssociations[]>('/api/teams');
}

/**
 * This is used by react-query for caching and invalidation.
 * This can contain anything (including objects like filters)
 * that can be used to uniquely identify the query.
 */
export const getTeamsQueryKey: QueryKey = ['teams'];

/**
 * useTeams is a hook that fetches and returns the teams the
 * current user has access to from /api/teams.
 */
export default function useTeams(shouldFetch: boolean = true) {
  return useQuery<TeamWithAssociations[]>({
    queryKey: getTeamsQueryKey,
    queryFn: fetchTeams,
    enabled: shouldFetch,
  });
}
